import { asyncLoad } from '@util'
const AsyncOssm = asyncLoad(() => import('@components/LocalMerchant/OSSM'))
const NiceCase = asyncLoad(() =>
  import('@components/LocalMerchant/OSSM/NiceCase')
)
export default [
  {
    path: 'ossm',
    component: AsyncOssm
  },
  {
    path: 'ossm/niceCase',
    component: NiceCase
  }
]
